import Weeks from "./testdata";

export default class WeekRepository {
    constructor() {
        this.weeks = Weeks;
    }

    getCalendarWeek(weekNumber) {
        return this.weeks.find((week) => week.weeknumber === weekNumber);
    }
}


// WEBPACK FOOTER //
// ./src/data/WeekRepository.js